import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { EditSiteMembershipDialog } from '../../userManagement/components/EditSiteMembershipDialog';
import { ISiteMembershipDialogScope, SiteMembershipDialogCtrl, SiteRolesEvent } from '../controllers/SiteMembershipDialogCtrl';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { FeatureFlags } from '../FeatureFlags';
import { IActionContext } from '../helpers/ActionContext';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ModalService, ModalSize } from './ModalService';
import { ModalInstance, ReactModalService } from './ReactModalService';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

export class EditSiteMembershipAction {

  public static $inject = ['ModalService', 'AngularContextFactory'];

  constructor(private modalService: ModalService, private angularContextFactory: AngularContextFactory) { }

  // TODO: use ConfimActionDialog
  public showEditSiteMembershipDialog(
    users: Set<IServerUserInfo>,
    context: IActionContext): ng.IPromise<any> {

    if (FeatureFlags.addActiveDirectoryServerUsersDialogReactEnabled) {
      let modalInstance: ModalInstance;
      let dialogScope: ng.IScope = context.scope.$new(true);

      const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
        close: (result: any) => modalInstance && modalInstance.close(result),
        emitSiteRolesChangedEvent: () => dialogScope.$emit(SiteRolesEvent.SiteRolesChanged),
        angularContext: this.angularContextFactory.create(dialogScope),
        users: users
      };

      modalInstance = ReactModalService.open({
        type: DialogType.Uber,
        dialogContent: React.createElement(EditSiteMembershipDialog, dialogProps),
        testId: 'addEditSiteMembershipDialog',
        showCloseButton: true,
        dialogStyle: serverAndSiteUsersDialogStyle,
        shouldNotSetDefaultWidth: true
      });

      return modalInstance.result;
    }
    const scope = <ISiteMembershipDialogScope> context.scope.$new(true);
    scope.users = users;

    const dialogInstance = this.modalService.open({
      scope: scope,
      templateUrl: 'siteMembershipDialog.html',
      size: ModalSize.fitToContent,
      controller: SiteMembershipDialogCtrl
    });

    return dialogInstance.result.finally(() => scope.$destroy());
  }

}

Module.instance().service('EditSiteMembershipAction', EditSiteMembershipAction);
